import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

const textPrimary = (theme) => ({
  color: theme.palette.text.primary,
  fontFamily: "'Quicksand', sans-serif",
});

export const RootBox = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

export const IntroSection = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
}));

export const IntroTypography = styled(Typography)(({ theme }) => ({
  ...textPrimary(theme),
  fontSize: "18px",
  paddingTop: theme.spacing(2),
  marginBottom: "-20px",
  fontWeight: 500,
  [theme.breakpoints.down("md")]: {
    fontSize: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.spacing(1.75),
  },
}));

export const BenefitItemBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  marginBottom: theme.spacing(1),
  [theme.breakpoints.down("md")]: {
    fontSize: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.spacing(1.75),
  },
}));

export const BulletTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: "20px",
  lineHeight: "24px",
  marginRight: theme.spacing(1),
  [theme.breakpoints.down("sm")]: {
    lineHeight: "20px",
  },
}));

export const BenefitTextTypography = styled(Typography)(({ theme }) => ({
  ...textPrimary(theme),
  fontSize: "18px",
  [theme.breakpoints.down("md")]: {
    fontSize: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.spacing(1.75),
  },
}));

export const CtaSection = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

export const CtaTypography = styled(Typography)(({ theme }) => ({
  ...textPrimary(theme),
  fontSize: "18px",
  marginTop: theme.spacing(2),
  [theme.breakpoints.down("md")]: {
    fontSize: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.spacing(1.75),
  },
}));

export const FormSection = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  marginTop: theme.spacing(2),
}));

export const FormTitleTypography = styled(Typography)(({ theme }) => ({
  ...textPrimary(theme),
  fontSize: "24px",
  marginBottom: theme.spacing(1),
  textAlign: "center",
  [theme.breakpoints.down("md")]: {
    fontSize: "20px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "18px",
  },
}));

export const FormIframe = styled("iframe")(({ height = "720px" }) => ({
  marginTop: "10px",
  width: "100%",
  height,
  border: "none",
  borderRadius: "3px",
}));
